























import Vue from 'vue';
import FieldCheckbox from '@/components/form/FieldCheckbox.vue';

export default Vue.extend({
  name: 'WidgetWrapper',
  components: { FieldCheckbox },

  props: {
    isCollapsed: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '',
    },
  },

  watch: {
    isActive(newValue) {
      this.checked = newValue;
    }
  },

  methods: {
    changeChecked() {
      this.$emit('changeChecked', +this.checked);
    }
  },

  data() {
    return {
      checked: this.isActive,
    };
  },
});
